<template>
    <div class="d-flex flex-column arrow-nav" :class="(direction == 'right') ? 'justify-content-end': 'justify-content-start'">
        <button class="btn">
            <router-link :to="route">
                <i class="bi" :class="'bi-chevron-' + direction"></i>
            </router-link>
        </button>
        <h6 class="route-name text-center">
            {{ routeName }}
        </h6>
    </div>
</template>

<script>
export default {
    name: "Arrow",
    props: ["direction", "route", "routeName"]
};
</script>
